<template>
    <div class="com-codics-hbb-order-admin-baojia-create-body" ref="bjBody">
        <div class="iconfont com-codics-hbb-order-admin-baojia-create-back" @click="jumpToPage('采购中心', {}, {})">&#xe842;
            返回页面
        </div>
        <div class="com-codics-hbb-order-admin-baojia-create-bar-content"
            style="width:100% !important;padding:50px 0 !important;">
            <MyStep v-model="stepNum" :data="stepData" :size="10"></MyStep>
        </div>
        <div class="com-codics-hbb-order-admin-baojia-create-bar-content com-codics-hbb-order-admin-baojia-create-bar-content2"
            style="margin-top: 10px;">
            <div v-for="(item, index) in cartData" :key="index" class="com-codics-hbb-order-admin-shop-car-item"
                v-show="stepNum == 1">
                <div class="com-codics-hbb-order-admin-shop-car-item-card">
                    <el-image class="com-codics-hbb-order-admin-shop-car-item-card-img"
                        :src="'https://cdn.bosscaigou.com/' + item.goodsInfo.img"></el-image>
                    <div class="com-codics-hbb-order-admin-shop-car-item-card-content">
                        <div class="com-codics-hbb-order-admin-shop-car-item-card-content-title">{{ item.goods.title
                            }}
                        </div>
                        <div class="com-codics-hbb-order-admin-shop-car-item-card-content-info">{{
                            item.goodsInfo.title }}</div>
                        <div class="com-codics-hbb-order-admin-shop-car-item-card-content-price">
                            <el-popover popper-class="com-codics-ui-sidebar-menu-item-popper" placement="top"
                                width="220" trigger="hover">
                                <el-form label-width="80px">
                                    <el-form-item label="商品报价">
                                        <el-input-number size="small" v-model="item.dp" :min="item.goodsInfo.np"
                                            :precision="2" :step="0.1"
                                            @change="handlePriceChange(item)"></el-input-number>
                                    </el-form-item>
                                </el-form>
                                <span slot="reference"
                                    style="color: #FE6446;font-size: 16px;font-weight: bolder;cursor: pointer;">
                                    <span style="font-size: 11px;font-weight: unset;">￥</span>
                                    {{ item.dp }}
                                    <span style="font-size: 11px;font-weight: unset;">报价</span>&nbsp;
                                    <span style="color: #999;font-size: 11px;font-weight: unset;">
                                        ￥{{ item.goodsInfo.np }}
                                    </span>
                                </span>
                            </el-popover>
                        </div>
                        <el-input-number class="com-codics-hbb-order-admin-shop-car-item-card-count" size="mini"
                            :min="0" :max="item.goodsInfo.inventory"
                            @change="(nowVal, oldVal) => handleCartCountChange(nowVal, oldVal, item)"
                            v-model="item.count"></el-input-number>
                    </div>
                </div>
            </div>
            <el-form v-show="stepNum == 2" :model="addForm" label-width="160px" style="margin-top: 30px;">
                <el-form-item label="报价单位" required>
                    <el-select style="float: left;" v-model="addForm.comInfo" filterable placeholder="请选择报价单位"
                        clearable>
                        <el-option v-for="(item, index) in comInfoOptions" :key="index"
                            :label="item.com + ' - ' + item.name" :value="item">
                        </el-option>
                    </el-select>
                    <MyButton style="margin-left:15px;" @click.native="comVisibile = true;">还没有？去创建</MyButton>
                </el-form-item>
                <el-form-item label="询价单位">
                    <el-select style="float: left;" v-model="addForm.cusInfo" filterable placeholder="请选择询价单位"
                        clearable>
                        <el-option v-for="(item, index) in cusInfoOptions" :key="index"
                            :label="item.com + ' - ' + item.name" :value="item">
                        </el-option>
                    </el-select>
                    <MyButton style="margin-left:15px;" @click.native="cusVisible = true;">还没有？去创建</MyButton>
                </el-form-item>
            </el-form>
            <el-form v-show="stepNum == 3" :model="addForm" label-width="160px" style="margin-top: 30px;">
                <el-form-item label="开票方式" required>
                    <el-select v-model="taxValue" style="float: left;" filterable placeholder="请选择开票方式" clearable
                        @change="handleTaxChange">
                        <el-option v-for="(item, index) in taxOptions" :key="index"
                            :label="'类型：' + ['普通发票', '增值税专用发票', '不开发票'][item.taxtype] + '-税率：' + item.tax + '%'"
                            :value="item.taxtype">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="对公信息" required>
                    <el-select style="float: left;" v-model="addForm.publicInfo" filterable placeholder="请选择对公信息"
                        clearable>
                        <el-option v-for="item in publicinfoOptions" :key="item.com"
                            :label="'名称：' + item.com + '-银行：' + item.bank + '-账户：' + item.acc" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-image v-show="stepNum > 3" style="left: 50%;transform: translateX(-50%);width: 100%;height: 300px;"
                src="https://cdn.bosscaigou.com/huayuan/img/%E6%8F%90%E4%BA%A4%E6%88%90%E5%8A%9F.svg"
                fit="contain"></el-image>
            <div v-show="stepNum > 3"
                style="position: relative;float:left;left: 50%;transform: translateX(-50%);width: 100%;margin-bottom: 40px;text-align: center;font-size: 14px;color: #777;">
                生成报价单成功</div>
            <el-button v-show="stepNum > 3" type="success"
                style="position: relative;float:left;left: 50%;transform: translateX(-50%);margin-top: 40px;margin-bottom: 50px;"
                plain @click="createXlsx">下载报价单（xlsx格式）</el-button>
            <!-- <el-button v-show="stepNum > 3" type="danger" @click="createPdf"
                style="position: relative;float:right;right: 40%;transform: translateX(50%);margin-top: 40px;margin-bottom: 50px;"
                plain>下载报价单（pdf格式）</el-button> -->
        </div>
        <div class="com-codics-hbb-order-admin-baojia-create-bottom-bar" ref="btBody">
            <span class="com-codics-hbb-order-admin-baojia-create-bottom-bar-price">报价(￥)：{{ cartPrice.toFixed(2)
                }}</span>
            <span class="com-codics-hbb-order-admin-baojia-create-bottom-bar-price"
                style="margin-left: 30px;color: #666;">成本(￥)：{{ costPrice.toFixed(2)
                }}</span>
            <span class="com-codics-hbb-order-admin-baojia-create-bottom-bar-price"
                style="margin-left: 30px;color: rgb(10 173 73);">利润(￥)：{{ (cartPrice - costPrice).toFixed(2)
                }}</span>
            <el-button v-show="stepNum < 4" @click="nextStep" size="small"
                style="position:relative;float:right;top:50%;transform:translateY(-50%);margin-right:10px"
                :type="stepNum == 3 ? 'success' : 'primary'">{{ stepNum == 3 ? '生成报价单' : '确认，下一步' }}</el-button>
            <el-dropdown v-show="stepNum < 4" split-button type="warning" size="small" plain
                style="float:right;top:50%;transform:translateY(-50%);margin-right:10px;" @click="savaRecord"
                @command="handleCommandClick">
                保存草稿
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) in recordData" :key="index" :command="item">{{ item.title
                        }}&nbsp;&nbsp;&nbsp;<span class="iconfont" style="float:right;"
                            @click.stop="delRecord(item)">&#xe850;</span><span style="float:right;">{{
                                initTime(item.time) }}&nbsp;&nbsp;&nbsp;</span></el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <el-button v-show="stepNum > 1 && stepNum < 4" @click="lastStep" size="small"
                style="position:relative;float:right;top:50%;transform:translateY(-50%);margin-right:10px"
                type="">返回上一步</el-button>
            <el-button v-show="stepNum > 3" @click="jumpToPage('订单管理', {}, {})" size="small"
                style="position:relative;float:right;top:50%;transform:translateY(-50%);margin-right:10px"
                type="success">返回管理页面</el-button>
        </div>
        <MyDialog v-model="bindUrlVisible" title="绑定详情链接" width="80%">
            <iframe ref="urlIframe" style="width:100%;height:70vh;position:relative;float:right;" :src="nowUrl"
                frameborder="0"></iframe>
            <MyButton style="margin-top:20px;margin-bottom:20px;float:right;" @click.native="bindUrlFuc">绑定当前页面
            </MyButton>
        </MyDialog>
        <MyDialog v-model="phoneDialog" title="绑定手机号">
            <el-input clearable
                style="margin-bottom: 70px;width: calc(50% - 7.5px) !important;position: relative;float: left;box-sizing: border-box;margin-top: 20px;font-size: 10px !important;"
                v-model="nowPhone" size="small" placeholder="请输入要绑定的手机号"></el-input>
            <el-button type="success" style="position: absolute;margin: auto;right: 15px;bottom: 15px;" size="mini"
                @click="bindPhoneFuc">确认绑定</el-button>
        </MyDialog>
        <el-dialog title="创建报价人" :visible.sync="comVisibile">
            <el-form :model="comForm" label-width="160px" style="margin-top: 30px;">
                <el-form-item label="报价单位" required>
                    <el-select style="float: left;" v-model="comInfoValue" filterable placeholder="请选择报价单位" clearable
                        @change="handleComChange">
                        <el-option v-for="(item, index) in comData" :key="index" :label="item.com" :value="item">
                        </el-option>
                    </el-select>
                    <el-popover placement="right" width="400" v-model="visible" trigger="hover">
                        <span style="margin-left: 15px;cursor: pointer;" slot="reference"
                            v-show="comForm.com == null"><span class="iconfont"
                                style="color:red;">&#xe85c;</span>关联位置信息！</span>
                        <el-image
                            src="https://cdn.bosscaigou.com/huayuan/img/yasuo_%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20250407172543.webp"
                            style="height: 319px;width: 400px;" fit="fill"></el-image>
                    </el-popover>
                </el-form-item>
                <el-form-item label="报价人" required>
                    <el-input v-model="comForm.name" placeholder="请输入报价人姓名" style="width:217px;" clearable></el-input>
                    <el-popover placement="right" width="400" v-model="visible" trigger="hover">
                        <span style="margin-left: 15px;cursor: pointer;" slot="reference"
                            v-show="comForm.name == ''"><span class="iconfont"
                                style="color:red;">&#xe85c;</span>关联位置信息！</span>
                        <el-image src="https://cdn.bosscaigou.com/huayuan/img/yasuo_1111.webp"
                            style="height: 294px;width: 400px;" fit="fill"></el-image>
                    </el-popover>
                </el-form-item>
                <el-form-item label="报价人联系方式" required>
                    <el-input v-model="comForm.phone" placeholder="请输入报价人联系方式" style="width:217px;"
                        clearable></el-input>
                    <el-popover placement="right" width="400" v-model="visible" trigger="hover">
                        <span style="margin-left: 15px;cursor: pointer;" slot="reference"
                            v-show="comForm.phone == ''"><span class="iconfont"
                                style="color:red;">&#xe85c;</span>关联位置信息！</span>
                        <el-image src="https://cdn.bosscaigou.com/huayuan/img/yasuo_1111.webp"
                            style="height: 294px;width: 400px;" fit="fill"></el-image>
                    </el-popover>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="comVisibile = false;">取 消</el-button>
                <el-button type="primary" @click="addComInfoFuc">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="添加询价单位" :visible.sync="cusVisible">
            <el-form :model="cusForm" label-width="160px" style="margin-top: 30px;">
                <el-form-item label="询价单位">
                    <el-input v-model="cusForm.com" placeholder="请输入询价单位名称" style="width:217px;" clearable></el-input>
                    <el-popover placement="right" width="400" v-model="visible" trigger="hover">
                        <span style="margin-left: 15px;cursor: pointer;" slot="reference"
                            v-show="cusForm.com == ''"><span class="iconfont"
                                style="color:red;">&#xe85c;</span>关联位置信息！</span>
                        <el-image src="https://cdn.bosscaigou.com/huayuan/img/yasuo_33333.webp"
                            style="height: 292px;width: 400px;" fit="fill"></el-image>
                    </el-popover>
                </el-form-item>
                <el-form-item label="询价单位地址">
                    <el-input v-model="cusForm.area" placeholder="请输入询价单位地址信息" style="width:217px;"
                        clearable></el-input>
                    <el-popover placement="right" width="400" v-model="visible" trigger="hover">
                        <span style="margin-left: 15px;cursor: pointer;" slot="reference"
                            v-show="cusForm.area == ''">关联位置信息！</span>
                        <el-image src="https://cdn.bosscaigou.com/huayuan/img/yasuo_33333.webp"
                            style="height: 292px;width: 400px;" fit="fill"></el-image>
                    </el-popover>
                </el-form-item>
                <el-form-item label="询价人">
                    <el-input v-model="cusForm.name" placeholder="请输入询价人姓名" style="width:217px;" clearable></el-input>
                    <el-popover placement="right" width="400" v-model="visible" trigger="hover">
                        <span style="margin-left: 15px;cursor: pointer;" slot="reference"
                            v-show="cusForm.name == ''"><span class="iconfont"
                                style="color:red;">&#xe85c;</span>关联位置信息！</span>
                        <el-image src="https://cdn.bosscaigou.com/huayuan/img/yasuo_1111.webp"
                            style="height: 294px;width: 400px;" fit="fill"></el-image>
                    </el-popover>
                </el-form-item>
                <el-form-item label="询价人联系方式">
                    <el-input v-model="cusForm.phone" placeholder="请输入询价人联系方式" style="width:217px;"
                        clearable></el-input>
                    <el-popover placement="right" width="400" v-model="visible" trigger="hover">
                        <span style="margin-left: 15px;cursor: pointer;" slot="reference"
                            v-show="cusForm.phone == ''"><span class="iconfont"
                                style="color:red;">&#xe85c;</span>关联位置信息！</span>
                        <el-image src="https://cdn.bosscaigou.com/huayuan/img/yasuo_1111.webp"
                            style="height: 294px;width: 400px;" fit="fill"></el-image>
                    </el-popover>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cusVisible = false;">取 消</el-button>
                <el-button type="primary" @click="addCusInfoFuc">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
import { mapState } from 'vuex';
import dayjs from 'dayjs';
import MyStep from '@/components/MyStep';
import MyButton from '@/components/MyButton';
import MyDialog from '@/components/MyDialog';
import { listGoods, addCart, deleteCart, listCart, clearCart, listGoodsBrand, listGoodsType, listTags, updatePrice, listComInfo, listCusInfo, listPublicInfo, addGoodsOrder, bindPhone, addComInfo, addCusInfo } from '@/api';
import { jumpTo, saveData, readData, delData, randomString } from '@/utils/myutils';
import Sortable from 'sortablejs';
import * as qiniu from 'qiniu-js';
import { hex_md5 } from '@/utils/md5';
import MyUpload from '@/components/MyUpload';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import jsPDF from "jspdf";
// 或显式注册（某些框架需要）
import { applyPlugin } from 'jspdf-autotable'
applyPlugin(jsPDF)
// const response = await fetch('../../../../public/js/ding-normal.txt');
// const dingNormal = await response.text();
export default {
    data() {
        return {
            cusForm: {
                com: '',
                area: '',
                name: '',
                phone: ''
            },
            cusVisible: false,
            comData: [
                {
                    com: '山东华远创智信息技术有限公司',
                    area: '山东省淄博市张店区宏程国际智谷大厦1605室',
                    icon: 'huayuan/map/yasuo_image1%20%281%29.webp',
                    seal: 'huayuan/img/yasuo_image2.webp'
                },
                {
                    com: '山东供应链有限公司',
                    area: '山东省滨州高新区小营街道安康路333号',
                    icon: 'huayuan/map/yasuo_image1%20%281%29.webp',
                    seal: 'huayuan/img/image3.png'
                }
            ],
            comForm: {
                com: null,
                name: '',
                phone: ''
            },
            comVisibile: false,
            cartData: [],
            comInfoOptions: [],
            cusInfoOptions: [],
            publicinfoOptions: [],
            taxValue: null,
            taxOptions: [
                // {
                //     taxtype: 0,
                //     tax: 3
                // },
                {
                    taxtype: 1,
                    tax: 13
                },
                {
                    taxtype: 2,
                    tax: 0
                },
            ],
            comInfoValue: null,
            cusInfoValue: null,
            inputTagVisible: false,
            inputTagValue: '',
            nowUrl: '',
            bindUrlVisible: false,
            stepNum: 1,
            stepData: [
                {
                    icon: '&#xe808;',
                    title: '采购信息',
                    content: '请仔细核对好报价单内包含的商品信息，确认后点击下一步'
                },
                {
                    icon: '&#xe7b8;',
                    title: '报价询价信息',
                    content: '请根据您的报价询价信息进行填写，填写完成后点击下一步'
                },
                {
                    icon: '&#xe6d6;',
                    title: '开票信息',
                    content: '请根据订单需要，选择合适的开票类型，填写完成后点击下一步'
                },
                {
                    icon: '&#xe84c;',
                    title: '生成报价单',
                    content: '报价单生成完成，手动返回或等待页面完成自动跳转'
                }
            ],
            qiNiuInfo: {
                token: ''
            },
            phoneDialog: false,
            nowPhone: '',
            typeOptions: [],
            brandOptions: [],
            baojiaData: null,
            himgList: [],
            dimgList: [],
            videoList: [],
            recordData: [],
            addForm: {
                cusInfo: '',
                comInfo: '',
                publicInfo: '',
                taxtype: '',
                tax: ''
            },
            himgSize: 0
        }
    },
    components: {
        MyButton,
        MyStep,
        MyUpload,
        MyDialog
    },
    mounted() {
        this.listCartFuc();
        this.readRecord();
        this.initListener();
        this.listComInfoFuc();
        this.listCusInfoFuc();
        this.listPublicInfoFuc();
    },
    methods: {
        async addCusInfoFuc() {

            if (this.cusForm.name == '') {
                this.$message({
                    showClose: true,
                    message: '询价人信息不能为空！',
                    type: 'warning'
                });
                return;
            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            this.cusForm.phone = this.cusForm.phone.toString();

            const data = await addCusInfo(this.cusForm);

            this.cusVisible = false;

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '创建询价单位成功！',
                    type: 'success'
                });

                this.listCusInfoFuc();

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        handleComChange(value) {
            if (value != '') {
                this.comForm = { ...this.comForm, ...value };
            } else {
                this.comForm.com = null;
                this.comForm.area = null;
                this.comForm.icon = null;
                this.comForm.seal = null;
            }
        },
        async addComInfoFuc() {

            if (this.comForm.com == null) {

                this.$message({
                    showClose: true,
                    message: '报价单位信息不能为空！',
                    type: 'warning'
                });

                return true;

            } else if (this.comForm.name == '' || this.comForm.phone == '') {

                this.$message({
                    showClose: true,
                    message: '报价人信息不能为空！',
                    type: 'warning'
                });

                return true;

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            this.comForm.phone = this.comForm.phone.toString();

            const data = await addComInfo(this.comForm);

            this.comVisibile = false;

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '创建报价人成功！',
                    type: 'success'
                });

                this.listComInfoFuc();

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }
        },
        async bindPhoneFuc() {
            const loading = this.$loading({
                lock: true,
                text: '绑定中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await bindPhone({ 'phone': this.nowPhone });
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '绑定成功！',
                    type: 'success'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 300);
            } else {
                if (data.code == 401) return;
                this.$message.error(data.message);
            }
        },
        async downloadFileToFileObject(url) {
            try {
                // 发送请求
                const response = await fetch(url);

                // 检查响应状态
                if (!response.ok) {
                    throw new Error(`HTTP请求失败，状态码：${response.status}`);
                }

                // 将响应转换为 Blob
                const blob = await response.blob();

                // 从响应头或自定义逻辑获取文件名
                const contentDisposition = response.headers.get('content-disposition');
                const fileName = contentDisposition
                    ? decodeURIComponent(contentDisposition.split('filename=')[1].replace(/"/g, ''))
                    : 'downloaded_file'; // 默认文件名

                // 将 Blob 转换为 File 对象
                const file = new File([blob], fileName, { type: blob.type });

                return file;
            } catch (error) {
                console.error('下载或转换失败:', error);
                throw error;
            }
        },
        // 图片转Base64工具函数
        async urlToBase64(url) {
            const response = await fetch(url);
            const blob = await response.blob();
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result.split(',')[1]);
                reader.readAsDataURL(blob);
            });
        },
        pxToEmu(px) {
            return Math.round(px * 9525);
        },
        createXlsx() {
            if (this.baojiaData == null) {
                this.$message.error('请先生成报价单！');
                return;
            }
            const _that = this;

            const reader = new FileReader()
            reader.onload = async (e) => {
                let templateBuffer = e.target.result
                let workbook = new ExcelJS.Workbook();
                workbook.calcProperties.fullCalcOnLoad = true;
                await workbook.xlsx.load(templateBuffer);
                const worksheet = workbook.getWorksheet('Sheet1');
                const insertRowIndex = 17;

                let cellData = [];

                let imageBase64 = await _that.urlToBase64('https://cdn.bosscaigou.com/' + this.baojiaData.comInfo?.icon);
                let imageId = workbook.addImage({
                    base64: imageBase64,
                    extension: 'png',
                });
                worksheet.addImage(imageId, {
                    tl: {
                        col: 1.1,
                        row: 3.05,
                        nativeColOff: 0,
                        nativeRowOff: 0
                    }, // 对应B2
                    br: {
                        col: 2.9,
                        row: 3.9,
                        nativeColOff: _that.pxToEmu(861) * 1.1,
                        nativeRowOff: _that.pxToEmu(359) * 1.1
                    },  // 占1列1行
                    // editAs: 'oneCell'        // 图片嵌入单元格
                });


                imageBase64 = await _that.urlToBase64('https://cdn.bosscaigou.com/' + this.baojiaData.comInfo?.seal);
                imageId = workbook.addImage({
                    base64: imageBase64,
                    extension: 'png',
                });
                worksheet.addImage(imageId, {
                    editAs: 'absolute',
                    tl: {
                        col: 1,
                        row: 3,
                        nativeColOff: 200 * 36000,
                        nativeRowOff: 200 * 36000
                    },
                    ext: { width: 240, height: 230 },
                });

                for (let i = 0; i < this.baojiaData.olist.length; i++) {

                    // const formula = worksheet.getRow(insertRowIndex + i).getCell(8).formula;

                    cellData.push(insertRowIndex + i);

                    worksheet.insertRow(insertRowIndex + i, [
                        '',
                        i + 1,
                        this.baojiaData.olist[i]?.goods?.title,
                        this.baojiaData.olist[i]?.title,
                        this.baojiaData.olist[i]?.unit,
                        parseInt(this.baojiaData.olist[i]?.count, 10),
                        parseFloat(this.baojiaData.olist[i]?.xp).toFixed(2),
                        this.baojiaData.olist[i]?.xp * this.baojiaData.olist[i]?.count,
                        ''
                    ]);

                    let imageBase64 = await _that.urlToBase64('https://cdn.bosscaigou.com/' + this.baojiaData.olist[i]?.img);
                    let imageId = workbook.addImage({
                        base64: imageBase64,
                        extension: 'png',
                    });
                    worksheet.addImage(imageId, {
                        tl: { col: 8, row: insertRowIndex + i - 1 }, // 对应B2
                        br: { col: 9, row: insertRowIndex + i },  // 占1列1行
                        editAs: 'oneCell'        // 图片嵌入单元格
                    });

                }

                worksheet.eachRow((row, rowNumber) => {
                    row.eachCell((cell) => {
                        console.log(cell);
                        if (cell.value && !cell.formula) {
                            cell.value = cell.value.toString().replace('#报价单位#', this.baojiaData.comInfo.com)
                                .replace('#报价单位地址#', this.baojiaData.comInfo.area)
                                .replace('#报价联系人#', this.baojiaData.comInfo.name)
                                .replace('#报价联系方式#', this.baojiaData.comInfo.phone)
                                .replace('#当前时间#', dayjs().format('YYYY年MM月DD日 HH:mm:ss'))
                                .replace('#询价单位#', this.baojiaData.cusInfo == null ? '' : this.baojiaData.cusInfo.com)
                                .replace('#询价单位地址#', this.baojiaData.cusInfo == null ? '' : this.baojiaData.cusInfo.area)
                                .replace('#询价联系人#', this.baojiaData.cusInfo == null ? '' : this.baojiaData.cusInfo.name)
                                .replace('#询价联系方式#', this.baojiaData.cusInfo == null ? '' : this.baojiaData.cusInfo.phone)
                                .replace('#发票类型#', ['普通发票', '增值税专用发票', '不开发票'][this.baojiaData.taxtype])
                                .replace('#税率#', this.baojiaData.tax)
                                .replace('#对公公司名称#', this.baojiaData.publicInfo.com)
                                .replace('#对公公司地址#', this.baojiaData.publicInfo.area)
                                .replace('#对公联系方式#', this.baojiaData.publicInfo.phone)
                                .replace('#对公税号#', this.baojiaData.publicInfo.tax)
                                .replace('#对公开户行#', this.baojiaData.publicInfo.bank)
                                .replace('#对公账号#', this.baojiaData.publicInfo.acc)
                                .replace('#对公行号#', this.baojiaData.publicInfo.bid);
                        }
                        if (cell.formula) {
                            cell.value = { formula: cell.formula }; // 重新绑定公式
                        }
                    });
                });



                // worksheet.insertRow(insertRowIndex, newData);

                // 复制前一行样式
                const referenceRow = worksheet.getRow(insertRowIndex + this.baojiaData.olist.length);

                cellData.forEach((cell, index) => {
                    worksheet.getRow(cell).eachCell((cell, colNumber) => {
                        const refCell = referenceRow.getCell(colNumber);
                        cell.style = JSON.parse(JSON.stringify(refCell.style));//refCell.style;//
                        cell.alignment = { ...refCell.alignment };
                        cell.fill = refCell.fill;
                    });
                });

                // worksheet.getRow(insertRowIndex).eachCell((cell, colNumber) => {
                //     const refCell = referenceRow.getCell(colNumber);
                //     cell.style = refCell.style;//JSON.parse(JSON.stringify(refCell.style));//
                //     cell.alignment = { ...refCell.alignment };
                //     cell.fill = refCell.fill;
                //     // cell.value = refCell.value; // 包括公式
                // });
                // 调整合并区域
                Object.entries(worksheet._merges).forEach(([key, value]) => {
                    let merge = worksheet._merges[key];
                    if (merge.bottom >= insertRowIndex) {
                        merge.bottom += this.baojiaData.olist.length; // 调整底部
                        merge.top += this.baojiaData.olist.length; // 调整顶部
                    }
                });

                worksheet.spliceRows(insertRowIndex + this.baojiaData.olist.length, 1);

                // 解除B5:D7合并
                // worksheet.unMergeCells('B5:D7');

                // worksheet.getRow(insertRowIndex + this.baojiaData.olist.length).getCell(6).value = 111;
                worksheet.getRow(insertRowIndex + this.baojiaData.olist.length).getCell(8).value = {
                    formula: `SUM(H${insertRowIndex}:H${insertRowIndex + this.baojiaData.olist.length - 1})`
                };
                worksheet.getRow(insertRowIndex + this.baojiaData.olist.length).getCell(6).value = {
                    formula: `SUM(F${insertRowIndex}:F${insertRowIndex + this.baojiaData.olist.length - 1})`
                };
                // 插入图片后重新合并
                worksheet.mergeCells(`B${insertRowIndex + this.baojiaData.olist.length}:E${insertRowIndex + this.baojiaData.olist.length}`);
                // 设置公式（假设F1=第1行第6列，F2=第2行第6列）
                worksheet.getRow(insertRowIndex + this.baojiaData.olist.length).getCell(8).numFmt = '0.00';
                worksheet.getColumn(6).numFmt = undefined;
                worksheet.getColumn(7).numFmt = undefined;

                this.baojiaData.olist.forEach((item, index) => {

                    worksheet.getCell(`F${insertRowIndex + index}`).value = parseInt(item.count, 10);

                    worksheet.getCell(`G${insertRowIndex + index}`).value = item.xp;

                    worksheet.getRow(insertRowIndex + index).getCell(6).numFmt = '0';

                    worksheet.getRow(insertRowIndex + index).getCell(7).numFmt = '0.00';

                    worksheet.getRow(insertRowIndex + index).getCell(8).numFmt = '0.00';

                    worksheet.getRow(insertRowIndex + index).getCell(8).value = {
                        formula: `F${insertRowIndex + index}*G${insertRowIndex + index}`
                    };

                });



                // worksheet.mergeCells(`B${insertRowIndex + this.baojiaData.olist.length + 1}:I${insertRowIndex + this.baojiaData.olist.length + 1}`);
                // worksheet.mergeCells('B5:D7');
                // 关键设置：强制Excel打开时重新计算所有公式
                workbook.calcProperties.fullCalcOnLoad = true;
                const buffer = await workbook.xlsx.writeBuffer(); // ✅ 浏览器端专用 API
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(blob, `${this.baojiaData?.comInfo?.name}报价单_` + `${this.baojiaData?.cusInfo == null ? '' : this.baojiaData?.cusInfo?.com}_` + `${this.baojiaData?.account?.id}_` + new Date().getTime() + '.xlsx');

            }
            // 调用函数并处理结果
            this.downloadFileToFileObject('https://cdn.bosscaigou.com/huayuan/xlsx/model.xlsx')
                .then(file => {
                    // console.log('File对象:', file);
                    reader.readAsArrayBuffer(file);

                })
                .catch(error => {
                    // 错误处理
                });
        },
        createPdf() {
            if (this.baojiaData == null) {
                this.$message.error('请先生成报价单！');
                return;
            }
            const _that = this;

            const reader = new FileReader()
            reader.onload = async (e) => {
                let templateBuffer = e.target.result
                let workbook = new ExcelJS.Workbook();
                workbook.calcProperties.fullCalcOnLoad = true;
                await workbook.xlsx.load(templateBuffer);
                const worksheet = workbook.getWorksheet('Sheet1');
                const insertRowIndex = 17;

                let cellData = [];

                let imageBase64 = await _that.urlToBase64('https://cdn.bosscaigou.com/' + this.baojiaData.comInfo?.icon);
                let imageId = workbook.addImage({
                    base64: imageBase64,
                    extension: 'png',
                });
                worksheet.addImage(imageId, {
                    tl: {
                        col: 1.1,
                        row: 3.05,
                        nativeColOff: 0,
                        nativeRowOff: 0
                    }, // 对应B2
                    br: {
                        col: 2.9,
                        row: 3.9,
                        nativeColOff: _that.pxToEmu(861) * 1.1,
                        nativeRowOff: _that.pxToEmu(359) * 1.1
                    },  // 占1列1行
                    // editAs: 'oneCell'        // 图片嵌入单元格
                });


                imageBase64 = await _that.urlToBase64('https://cdn.bosscaigou.com/' + this.baojiaData.comInfo?.seal);
                imageId = workbook.addImage({
                    base64: imageBase64,
                    extension: 'png',
                });
                worksheet.addImage(imageId, {
                    editAs: 'absolute',
                    tl: {
                        col: 1,
                        row: 3,
                        nativeColOff: 200 * 36000,
                        nativeRowOff: 200 * 36000
                    },
                    ext: { width: 240, height: 230 },
                });









                for (let i = 0; i < this.baojiaData.olist.length; i++) {

                    // const formula = worksheet.getRow(insertRowIndex + i).getCell(8).formula;

                    cellData.push(insertRowIndex + i);

                    worksheet.insertRow(insertRowIndex + i, [
                        '',
                        i + 1,
                        this.baojiaData.olist[i]?.goods?.title,
                        this.baojiaData.olist[i]?.title,
                        '',
                        parseInt(this.baojiaData.olist[i]?.count, 10),
                        parseFloat(this.baojiaData.olist[i]?.xp).toFixed(2),
                        this.baojiaData.olist[i]?.xp * this.baojiaData.olist[i]?.count,
                        ''
                    ]);

                    let imageBase64 = await _that.urlToBase64('https://cdn.bosscaigou.com/' + this.baojiaData.olist[i]?.img);
                    let imageId = workbook.addImage({
                        base64: imageBase64,
                        extension: 'png',
                    });
                    worksheet.addImage(imageId, {
                        tl: { col: 8, row: insertRowIndex + i - 1 }, // 对应B2
                        br: { col: 9, row: insertRowIndex + i },  // 占1列1行
                        editAs: 'oneCell'        // 图片嵌入单元格
                    });

                }

                worksheet.eachRow((row, rowNumber) => {
                    row.eachCell((cell) => {
                        if (cell.value && !cell.formula) {
                            cell.value = cell.value.toString().replace('#报价单位#', this.baojiaData.comInfo.com)
                                .replace('#报价单位地址#', this.baojiaData.comInfo.area)
                                .replace('#报价联系人#', this.baojiaData.comInfo.name)
                                .replace('#报价联系方式#', this.baojiaData.comInfo.phone)
                                .replace('#当前时间#', dayjs().format('YYYY年MM月DD日 HH:mm:ss'))
                                .replace('#询价单位#', this.baojiaData.cusInfo == null ? '' : this.baojiaData.cusInfo.com)
                                .replace('#询价单位地址#', this.baojiaData.cusInfo == null ? '' : this.baojiaData.cusInfo.area)
                                .replace('#询价联系人#', this.baojiaData.cusInfo == null ? '' : this.baojiaData.cusInfo.name)
                                .replace('#询价联系方式#', this.baojiaData.cusInfo == null ? '' : this.baojiaData.cusInfo.phone)
                                .replace('#发票类型#', ['普通发票', '增值税专用发票', '不开发票'][this.baojiaData.taxtype])
                                .replace('#税率#', this.baojiaData.tax)
                                .replace('#对公公司名称#', this.baojiaData.publicInfo.com)
                                .replace('#对公公司地址#', this.baojiaData.publicInfo.area)
                                .replace('#对公联系方式#', this.baojiaData.publicInfo.phone)
                                .replace('#对公税号#', this.baojiaData.publicInfo.tax)
                                .replace('#对公开户行#', this.baojiaData.publicInfo.bank)
                                .replace('#对公账号#', this.baojiaData.publicInfo.acc)
                                .replace('#对公行号#', this.baojiaData.publicInfo.bid);
                        }
                        if (cell.formula) {
                            cell.value = { formula: cell.formula }; // 重新绑定公式
                        }
                    });
                });



                // worksheet.insertRow(insertRowIndex, newData);

                // 复制前一行样式
                const referenceRow = worksheet.getRow(insertRowIndex + this.baojiaData.olist.length);

                cellData.forEach((cell, index) => {
                    worksheet.getRow(cell).eachCell((cell, colNumber) => {
                        const refCell = referenceRow.getCell(colNumber);
                        cell.style = JSON.parse(JSON.stringify(refCell.style));//refCell.style;//
                        cell.alignment = { ...refCell.alignment };
                        cell.fill = refCell.fill;
                    });
                });

                // worksheet.getRow(insertRowIndex).eachCell((cell, colNumber) => {
                //     const refCell = referenceRow.getCell(colNumber);
                //     cell.style = refCell.style;//JSON.parse(JSON.stringify(refCell.style));//
                //     cell.alignment = { ...refCell.alignment };
                //     cell.fill = refCell.fill;
                //     // cell.value = refCell.value; // 包括公式
                // });
                // 调整合并区域
                Object.entries(worksheet._merges).forEach(([key, value]) => {
                    let merge = worksheet._merges[key];
                    if (merge.bottom >= insertRowIndex) {
                        merge.bottom += this.baojiaData.olist.length; // 调整底部
                        merge.top += this.baojiaData.olist.length; // 调整顶部
                    }
                });

                worksheet.spliceRows(insertRowIndex + this.baojiaData.olist.length, 1);

                // 解除B5:D7合并
                // worksheet.unMergeCells('B5:D7');

                // worksheet.getRow(insertRowIndex + this.baojiaData.olist.length).getCell(6).value = 111;
                worksheet.getRow(insertRowIndex + this.baojiaData.olist.length).getCell(8).value = {
                    formula: `SUM(H${insertRowIndex}:H${insertRowIndex + this.baojiaData.olist.length - 1})`
                };
                worksheet.getRow(insertRowIndex + this.baojiaData.olist.length).getCell(6).value = {
                    formula: `SUM(F${insertRowIndex}:F${insertRowIndex + this.baojiaData.olist.length - 1})`
                };
                // 插入图片后重新合并
                worksheet.mergeCells(`B${insertRowIndex + this.baojiaData.olist.length}:E${insertRowIndex + this.baojiaData.olist.length}`);
                // 设置公式（假设F1=第1行第6列，F2=第2行第6列）

                worksheet.getColumn(6).numFmt = undefined;
                worksheet.getColumn(7).numFmt = undefined;

                this.baojiaData.olist.forEach((item, index) => {

                    worksheet.getCell(`F${insertRowIndex + index}`).value = parseInt(item.count, 10);

                    worksheet.getCell(`G${insertRowIndex + index}`).value = item.xp;

                    worksheet.getRow(insertRowIndex + index).getCell(6).numFmt = '0';

                    worksheet.getRow(insertRowIndex + index).getCell(7).numFmt = '0.00';

                    worksheet.getRow(insertRowIndex + index).getCell(8).numFmt = '0.00';

                    worksheet.getRow(insertRowIndex + index).getCell(8).value = {
                        formula: `F${insertRowIndex + index}*G${insertRowIndex + index}`
                    };

                });



                // worksheet.mergeCells(`B${insertRowIndex + this.baojiaData.olist.length + 1}:I${insertRowIndex + this.baojiaData.olist.length + 1}`);
                // worksheet.mergeCells('B5:D7');
                // 关键设置：强制Excel打开时重新计算所有公式
                workbook.calcProperties.fullCalcOnLoad = true;
                const data = _that.parseWorksheet(worksheet);     // 自定义解析函数
                _that.generatePDF(data);

            }
            // 调用函数并处理结果
            this.downloadFileToFileObject('https://cdn.bosscaigou.com/huayuan/xlsx/model.xlsx')
                .then(file => {
                    // console.log('File对象:', file);
                    reader.readAsArrayBuffer(file);

                })
                .catch(error => {
                    // 错误处理
                });

        },
        parseWorksheet(worksheet) {
            const data = [];
            // 遍历所有行
            worksheet.eachRow((row, rowNumber) => {
                const rowData = [];
                row.eachCell((cell, colNumber) => {
                    console.log('1', cell);
                    rowData.push({
                        value: cell?.value || '',                   // 单元格文本
                        styles: cell?.style || {},           // 字体、颜色等样式
                        merge: cell?.master ? 'merged' : ''  // 合并单元格标记
                    });
                });
                data.push(rowData);
            });
            return data;
        },
        generatePDF(data) {
            const pdf = new jsPDF('p', 'pt', 'a4');
            pdf.addFileToVFS("ding", dingNormal);
            pdf.addFont("ding", "d", "normal");
            pdf.setFont("d");

            const columns = data[0].map((_, idx) => ({ header: `列${idx + 1}`, dataKey: idx }));
            // 定义表格配置
            pdf.autoTable({
                head: [data[0].map(cell => cell.value)], // 表头
                body: data.slice(1).map(row => row.map(cell => cell.value)),
                columns: columns,
                styles: {
                    fontSize: 10,
                    cellPadding: 5,
                    overflow: 'linebreak'
                },
                // 自定义单元格样式
                didParseCell: (cellData) => {
                    const excelCell = data[cellData.row.index][cellData.column.index];
                    if (excelCell && excelCell.styles.font?.bold) {
                        if (cellData.cell.styles != null) cellData.cell.styles.fontStyle = 'bold';
                    }
                    if (excelCell && excelCell.merge === 'merged') {
                        cellData.cell.styles.fillColor = [240, 240, 240]; // 合并单元格背景色
                    }
                }
            });

            pdf.save('output.pdf');
        },
        async addGoodsOrderFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await addGoodsOrder(this.addForm);

            loading.close();

            if (data.code == 200) {

                this.stepNum++;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        handleTaxChange(value) {
            this.addForm.taxtype = value;
            this.addForm.tax = [3, 13, 0][value];
        },
        async listPublicInfoFuc() {

            const data = await listPublicInfo();

            if (data.code == 200) {

                this.publicinfoOptions = data.data;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async listComInfoFuc() {

            const data = await listComInfo();

            if (data.code == 200) {

                this.comInfoOptions = data.data;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async listCusInfoFuc() {

            const data = await listCusInfo();

            if (data.code == 200) {

                this.cusInfoOptions = data.data;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async addCartFuc(item) {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await addCart({ id: item.id, count: item.count });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: item.oid == null ? '加入购物车成功！' : '修改数量成功！',
                    type: 'success'
                });

                this.cartData = data.data;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        handleCartCountChange(nowVal, oldVal, item) {

            if (nowVal == 0) {

                this.$confirm('此操作将删除该商品, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.addCartFuc(item);
                }).catch(() => {
                    item.count = oldVal;
                });

            } else {

                this.addCartFuc(item);

            }

        },
        initListener() {
            const bjBody = this.$refs.bjBody;
            const btBody = this.$refs.btBody;
            const observer = new ResizeObserver(entries => {
                entries.forEach(entry => {
                    const { width, height } = entry.contentRect;
                    btBody.style.width = bjBody.clientWidth + 'px';
                });
            });
            observer.observe(bjBody); // 开始监听
            // bjBody.addEventListener('resize', () => {
            //     console.log(btBody.style.width, bjBody.style.width)
            //     btBody.style.width = bjBody.clientWidth + 'px';
            // });
        },
        async handlePriceChange(item) {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await updatePrice({ id: item.id, price: item.dp });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '价格修改成功！',
                    type: 'success'
                });

                this.cartData = data.data;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async listCartFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await listCart();

            loading.close();

            if (data.code == 200) {

                this.cartData = data.data;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        handleTagClose(tag) {
            this.addForm.tags = this.addForm.tags.filter(item => item.tag != tag.tag);
        },
        handleInputConfirm() {
            let inputValue = this.inputTagValue;
            this.addForm.tags = this.addForm.tags == null ? [] : this.addForm.tags;
            if (inputValue) {
                this.addForm.tags.push({
                    tag: inputValue
                });
            }
            this.inputTagVisible = false;
            this.inputTagValue = '';
        },
        showInput() {
            this.inputTagVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        handleCommandClick(item) {
            this.addForm = item.addForm;
            this.himgList = item.himgList;
            this.dimgList = item.dimgList;
            this.videoList = item.videoList;
            this.$message({
                showClose: true,
                message: '记录恢复成功！',
                type: 'success'
            });
        },
        async initAreaData(t, txt, count) {
            count++;
            Object.keys(areaData[txt]).forEach(key => {
                let tt = count == 1 ? {
                    value: areaData[txt][key],
                    label: areaData[txt][key],
                    children: []
                } : {
                    value: areaData[txt][key],
                    label: areaData[txt][key],
                };
                t.push(tt)
                count < 2 && this.initAreaData(tt.children, key, count);
            });
        },
        async listGoodsBrandFuc() {
            const data = await listGoodsBrand();
            if (data.code == 200) {
                this.brandOptions = data.data;
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
        },
        async listGoodsTypeFuc() {
            const data = await listGoodsType();
            if (data.code == 200) {
                this.typeOptions = data.data;
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
        },
        openBindDialog() {
            this.bindUrlVisible = true;
            const el = this.$refs.urlIframe;
            el.src = 'https://www.bosscaigou.com/all_products.html';
        },
        bindUrlFuc() {

            const el = this.$refs.urlIframe;
            el.contentWindow.postMessage('getURL', '*');
            // 监听iframe返回的消息
            window.addEventListener('message', (event) => {
                if (event.data.type === 'currentURL') {
                    this.bindUrlVisible = false;
                    console.log('iframe当前URL:', event.data.url);
                    this.addForm.url = event.data.url;
                }
            });
        },
        async nextStep() {

            if (this.userInfo?.user?.phone === '' || this.userInfo?.user?.phone == null) {

                this.$message({
                    showClose: true,
                    message: '请先绑定手机号！',
                    type: 'warning'
                });

                this.phoneDialog = true;

                return true;

            }

            if (this.stepNum == 1) {

                if (this.cartData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '采购商品不能为空！',
                        type: 'warning'
                    });

                    return true;

                }

                this.stepNum++;

            } else if (this.stepNum == 2) {

                if (this.addForm.comInfo == '') {

                    this.$message({
                        showClose: true,
                        message: '请先选择报价单位！',
                        type: 'warning'
                    });

                    return;

                }

                this.stepNum++;

            } else if (this.stepNum == 3) {

                if (this.addForm.taxtype === '' || this.addForm.tax === '') {

                    this.$message({
                        showClose: true,
                        message: '请先选择发票类型！',
                        type: 'warning'
                    });

                    return;

                }

                if (this.addForm.publicInfo == '') {

                    this.$message({
                        showClose: true,
                        message: '请先选择对公信息！',
                        type: 'warning'
                    });

                    return;

                }

                this.addForm.cusInfo = this.addForm.cusInfo == '' ? null : this.addForm.cusInfo;

                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                const data = await addGoodsOrder(this.addForm);

                loading.close();

                if (data.code == 200) {

                    this.stepNum++;

                    this.baojiaData = data.data;

                    this.$message({
                        showClose: true,
                        message: '报价单生成成功！',
                        type: 'success'
                    });

                } else {

                    if (data.code == 401) return;

                    this.$message.error(data.message);

                }

            }
        },
        lastStep() {
            this.stepNum--;
        },
        jumpToPage(n, p, q) {
            jumpTo(this, n, p, q);
        },
        roleChange() {

            if (this.nowSearchTxt == '') {

                this.currentPage = 1;

                this.dataSize = 10;

                this.tableData = [];

                this.listGoodssFuc();

            } else {

                this.searchPage = 1;

                this.searchSize = 10;

                this.searchData = [];

                this.listGoodssFuc();

            }

        },
        async listRoleFuc() {

            const data = await listRole();

            if (data.code == 200) {

                this.roleData = data.data;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        addGoodsCommand(a) {
            switch (a) {
                case '直接创建':
                    this.registerDialog2 = true;
                    break;
                case '邀请注册':
                    this.registerDialog = true;
                    break;
            }
        },
        searchGoodss() {

            if (this.searchTxt == '') {

                this.$message.error('请先输入要搜索的内容！');

                return;

            }

            this.searchPage = 1;

            this.searchMax = 0;

            this.searchData = [];

            this.nowSearchTxt = this.searchTxt;

            this.listGoodssFuc();

        },
        async listGoodssFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await listGoods({
                key: this.nowSearchTxt,
                pge: this.searchTxt == '' ? this.currentPage : this.searchPage,
                psz: this.searchTxt == '' ? this.dataSize : this.searchSize,
                type: this.goods - addType,
                brand: this.goods - addBrand
            });

            loading.close();

            if (data.code == 200) {

                if (this.searchTxt == '') {

                    this.tableData = data.data;

                    this.maxSize = data.count;

                } else {

                    this.searchData = data.data;

                    this.searchMax = data.count;

                }

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async repassGoodssFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要重置的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await repassGoodss({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '共' + data.count + '条数据重置成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async deleteGoodssFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await deleteGoodss({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: data.count + '条数据重置成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        handleSizeChange(val) {
            if (this.searchTxt == '') {
                this.dataSize = val;
            } else {
                this.searchSize = val;
            }
            this.listGoodssFuc();
        },
        handleCurrentChange(val) {
            if (this.searchTxt == '') {
                this.currentPage = val;
            } else {
                this.searchPage = val;
            }
            this.listGoodssFuc();
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        searchChange(a) {
            if (a == '') {
                this.searchPage = 1;
                this.searchData = [];
                this.searchMax = 0;
                this.searchSize = 10;
                this.nowSearchTxt = '';
            }
        },
        initTime(str) {
            return dayjs(str).format('YYYY-MM-DD HH:mm:ss');
        },
        // 上传方法
        uploadHimg(uploadInfo) {

            // this.initDragSort(this.$refs.himgUpload, this.himgList);

            if (this.himgList.length >= 5) {
                this.$message({
                    showClose: true,
                    message: '最多上传5张图片！',
                    type: 'warning'
                });
                return;
            }

            this.himgList.push('huayuan/img/' + hex_md5(uploadInfo.file.name) + '_' + new Date().getTime() + '.png');

            this.himgSize = this.himgList.length;

            const _that = this;
            // 上传文件
            const observer = {
                next(res) {
                    // console.log('next: ', res)
                },
                error(err) {
                    // console.log(err)
                },
                complete(res) {
                    // console.log('complete: ', res)
                    console.log(res.key)
                    console.log(_that.himgList.length)

                }
            }
            // console.log(uploadInfo.file);
            const observable = qiniu.upload(uploadInfo.file, 'huayuan/img/' + hex_md5(uploadInfo.file.name) + '_' + new Date().getTime() + '.png', this.qiNiuInfo.token, {}, {

            })
            const subscription = observable.subscribe(observer) // 上传开始
            // console.log(subscription);
            // subscription.unsubscribe() // 上传取消
        },
        initDragSort(el, list) {
            Sortable.create(el, {
                onEnd: ({ oldIndex, newIndex }) => {
                    // 交换位置
                    const arr = list;
                    const page = arr[oldIndex];
                    arr.splice(oldIndex, 1);
                    arr.splice(newIndex, 0, page);

                }
            });
        },
        handleRemove(file) {
            this.himgList = this.himgList.filter(item => item.indexOf(file.name.replace(',', '')) == -1);
            this.himgSize = this.himgList.length;
        },
        savaRecord() {
            if (this.addForm.title == '') {
                this.$message({
                    showClose: true,
                    message: '请先填写商品名称再尝试保存！',
                    type: 'warning'
                });
                return;
            }
            let data = readData("codics-hbb-baojia-create-record");
            console.log(data);
            if (data == null) {
                let t = [];
                t.push({
                    'tid': 'CHGAR-' + randomString(10) + '-' + new Date().getTime(),
                    'title': this.addForm.title,
                    'time': new Date(),
                    'addForm': this.addForm,
                    'himgList': this.himgList,
                    'dimgList': this.dimgList,
                    'videoList': this.videoList
                });
                saveData("codics-hbb-baojia-create-record", JSON.stringify(t));
            } else {
                let t = JSON.parse(data);
                if (t.length >= 10) {
                    this.$message({
                        showClose: true,
                        message: '保存数量到上限，请删除部分后再尝试保存！',
                        type: 'warning'
                    });
                    return;
                }
                t.push({
                    'tid': 'CHGAR-' + randomString(10) + '-' + new Date().getTime(),
                    'title': this.addForm.title,
                    'time': new Date(),
                    'addForm': this.addForm,
                    'himgList': this.himgList,
                    'dimgList': this.dimgList,
                    'videoList': this.videoList
                });
                saveData("codics-hbb-baojia-create-record", JSON.stringify(t));
            }
            this.readRecord();
            this.$message({
                showClose: true,
                message: '记录保存成功！',
                type: 'success'
            });
        },
        readRecord() {
            this.recordData = [];
            let data = readData("codics-hbb-baojia-create-record");
            this.recordData = data == null ? [] : JSON.parse(data);
        },
        delRecord(itm) {
            let t = JSON.parse(readData("codics-hbb-baojia-create-record"));
            t = t.filter(item => item.tid != itm.tid);
            saveData("codics-hbb-baojia-create-record", JSON.stringify(t));
            this.readRecord();
            this.$message({
                showClose: true,
                message: '记录删除成功！',
                type: 'success'
            });
        },
        addGoodsInfo() {
            let arr = this.addForm.info == null ? [] : this.addForm.info;
            arr.forEach(item => {
                item.small = true;
            });
            arr.push({
                'img': [],
                'title': '',
                'op': 0,
                'np': 0,
                'inventory': 0,
                'remark': '',
                'state': 0,
                'small': false
            });
            this.addForm.info = arr;
        },
        deleteInfoItem(idx) {
            this.addForm.info.splice(idx, 1);
        }
    },
    computed: {
        ...mapState(['userInfo']),
        listAddState() {

            return this.$refs['fmUpload'] < 5;

        },
        cartPrice() {
            let price = 0;
            this.cartData.forEach(item => {
                price += (item.dp * item.count);
            });
            return price;
        },
        costPrice() {
            let price = 0;
            this.cartData.forEach(item => {
                price += (item.goodsInfo.np * item.count);
            });
            return price;
        }
    }
}
</script>

<style>
.com-codics-hbb-order-admin-baojia-create-body {
    height: calc(100vh - 100px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    overflow-y: scroll;
    width: calc(100% + 20px);
    overflow-y: scroll;
    padding-right: 20px;
}

:root {
    --baojia-create-back-font-color: #333;
    --baojia-create-bottom-bg-color: #FFF;
    --baojia-create-bottom-shadow-color: #EBEBEB;
}

:root[data-theme="dark"] {
    --baojia-create-back-font-color: #FFF;
    --baojia-create-bottom-bg-color: #292b2c;
    --baojia-create-bottom-shadow-color: #2E3235;
}

.com-codics-hbb-order-admin-baojia-create-back {
    height: 50px;
    width: 100%;
    position: relative;
    float: left;
    line-height: 50px;
    box-sizing: border-box;
    font-size: 14px;
    color: var(--baojia-create-back-font-color);
    font-weight: bolder;
    cursor: pointer;
    transition: .3s;
    user-select: none;
    margin-bottom: 5px;
    -webkit-user-drag: none;
}

.com-codics-hbb-order-admin-baojia-create-bottom-bar {
    height: 50px;
    width: 100%;
    position: fixed;
    bottom: 0;
    right: 0;
    box-sizing: border-box;
    background: #FFF;
    background: var(--baojia-create-bottom-bg-color);
    border: 1px solid #EBEBEB;
    border: 1px solid var(--baojia-create-bottom-shadow-color);
    transition: .1s;
    padding-left: 20px;
    z-index: 100;
}

.com-codics-hbb-order-admin-baojia-create-bar-content {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: var(--sbar-bg-color);
    border-radius: 6px;
    border: 1px solid var(--sbar-l-3-color);
    padding: 15px;
    transition: .3s;
}

.com-codics-hbb-order-admin-baojia-create-bar-content2 {
    box-sizing: border-box;
    padding: 20px;
}

.com-codics-hbb-order-admin-baojia-create-bar-pick {
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-right: 15px;
}

.com-codics-hbb-order-admin-baojia-create-bar-input {
    width: 220px !important;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-news-pagination {
    height: fit-content;
    position: relative;
    float: left;
    /* left: 50%; */
    margin-top: 20px;
    /* transform: translateX(-50%); */
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
    background-color: var(--el-table-page-bg-color) !important;
    color: var(--el-table-page-font-color) !important;
}

.el-pagination.is-background .el-pager .active {
    background-color: var(--el-table-page-bg-active-color) !important;
    color: var(--el-table-page-font-active-color) !important;
}

.com-codics-hbb-order-admin-goods-img-upload .el-upload {
    display: var(--dataSize);
}

/* .com-codics-hbb-order-admin-baojia-create-info-box{
    height:fit-content;
} */

.com-codics-hbb-order-admin-baojia-create-info-item-delete {
    height: 40px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 40px;
    cursor: pointer;
    transition: .3s;
    user-select: none;
    -webkit-user-drag: none;
    font-size: 15px;
    color: #333;
    text-align: center;
    margin-top: 15px;
}

.com-codics-hbb-order-admin-baojia-create-info-item-delete::before {
    content: '';
    height: 1px;
    width: 95%;
    position: absolute;
    margin: auto;
    left: 0;
    top: -15px;
    right: 0;
    background: #EBEBEB;
}

.com-codics-hbb-order-admin-baojia-create-info-item-delete:hover {
    background: rgba(0, 0, 0, .3);
}

.com-codics-hbb-order-admin-baojia-create-info-item-del-btn {
    position: absolute;
    margin: auto;
    top: 50px;
    right: 20px;
    user-select: none;
    -webkit-user-drag: none;
}

.com-codics-hbb-order-admin-baojia-create-info-item {
    height: 100px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-bottom: 20px;
}

.com-codics-hbb-order-admin-baojia-create-info-item-img {
    height: 100px;
    width: 100px;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.com-codics-hbb-order-admin-baojia-create-info-item-title {
    height: 50px;
    width: calc(100% - 200px);
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 50px;
    font-size: 14px;
    color: #333;
    text-align: left;
    padding-left: 20px;
}

.com-codics-hbb-order-admin-baojia-create-info-item-price {
    height: 50px;
    width: calc(100% - 200px);
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 50px;
    font-size: 14px;
    color: #333;
    text-align: left;
    padding-left: 20px;
}

.com-codics-hbb-order-admin-baojia-create-bottom-bar-price {
    height: 50px;
    width: fit-content;
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 50px;
    font-size: 14px;
    text-align: left;
    color: #FE6446;
    font-weight: bolder;
}
</style>